export const buildBreadcrumbsList = (taxon) => {
  const breadcrumb = {
    id: taxon.id,
    code: taxon.code,
    name: taxon.name,
    slug: taxon.slug,
    level: taxon.level,
  };

  if (taxon.parent && taxon.parent.level > 0) {
    return [...buildBreadcrumbsList(taxon.parent), breadcrumb];
  }

  return [breadcrumb];
};



// WEBPACK FOOTER //
// ./utils/buildBreadcrumbsList.js